import {
    IDENTIFICATION_DOCUMENT_TYPES,
    ORDER_CREATE_DEFAULT_CUSTOMER_INFO,
    GENDER_OPTIONS,
} from "@/libs/const";
import { httpClient } from "@/libs/http";
import { compress } from "image-conversion";
import moment from "moment";

export default {
    components: {},
    props: {
        isShowAll: {
            type: Boolean,
            default: () => true,
        },
        info: {
            type: Object,
            default: () => { },
        },
        channels: {
            type: Array,
            default: () => [],
        },
        countries: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        order: { ...ORDER_CREATE_DEFAULT_CUSTOMER_INFO },
        isShowInfo: true,
        genderOptions: [...GENDER_OPTIONS],
        documentTypeOptions: [...IDENTIFICATION_DOCUMENT_TYPES],
        items: [],
        file: null,
    }),
    computed: {
        channelOptions() {
            if (!this.channels || this.channels.length === 0) {
                return [];
            }
            return [...this.channels].map((c) => ({
                text: c.name,
                value: c.id,
            }));
        },
        countryOptions() {
            if (!this.countries || this.countries.length === 0) {
                return [];
            }
            return [...this.countries].map((c) => ({
                text: c.name,
                value: c.id,
            }));
        },
    },
    watch: {
        order: {
            handler() {
                this.$emit("onUpdate", this.order);
            },
            deep: true,
        },
    },
    mounted() {
        if (this.info && this.info.id) {
            this.order = {
                ...this.order,
                id_channel: this.info.id_channel,
                contact_value: this.info.contact_value,
                identification_document_type: this.info.identification_document_type,
                identification_document_number:
                    this.info.identification_document_number,
                identification_document_image: this.info.identification_document_image,
                id_country: this.info.id_country,
                gender: this.info.gender,
                name: this.info.name,
                date_of_birth: this.info.date_of_birth,
            };
        }
    },
    methods: {
        documentImageLink() {
            return `${process.env.VUE_APP_FILE_CDN_URL}/${this.order.identification_document_image}`;
        },
        removeDocumentImage() {
            this.order = { ...this.order, identification_document_image: null };
        },
        onReset() {
            this.order = { ...ORDER_CREATE_DEFAULT_CUSTOMER_INFO };
        },
        onInputFileChange(file) {
            if (file) {
                this.uploadFile(file);
                this.readIdentificationDocument(file);
            }
        },
        async readIdentificationDocument(file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                try {
                    const { data } = await httpClient.post(
                        "/common/v1/read-identification-document",
                        {
                            data_image: reader.result,
                        }
                    );
                    console.log(data);
                    this.$emit('onDocumentRead', true)
                    let country = {};
                    if (data.nationality) {
                        country = this.countries.find((ct) => ct.name == data.nationality);
                    }
                    const documentType = {
                        id_card: 1,
                        passport: 2,
                        drivers_license: 3,
                    };
                    const updateData = {
                        name: data.full_name,
                        identification_document_number: data.document_number,
                        identification_document_type: data.type_of_document
                            ? documentType[data.type_of_document]
                            : null,
                        date_of_birth: data.date_of_birth,
                        gender: ["F", "Female", "Nữ"].includes(data.gender) ? 2 : 1,
                        id_country: data.id_country || (country && country.id) || null,
                    };

                    if (data.id_channel) {
                        updateData.id_channel = data.id_channel;
                    }

                    if (data.contact_value) {
                        updateData.contact_value = data.contact_value;
                    }

                    this.order = {
                        ...this.order,
                        ...updateData,
                    };
                } catch (error) {
                    this.$emit('onDocumentRead', true)
                    console.error("Error reading file:", error);
                }
            };
        },
        async uploadFile(file) {
            const resBlob = await compress(file, {
                quality: 0.85,
                width: 1024,
                type: "image/jpeg",
            });
            const newFile = new File(
                [resBlob],
                `${moment().unix()}_${this.generateRandomString(10)}.jpg`,
                { type: "image/jpeg" }
            );
            let fd = new FormData();
            fd.append("file", newFile);
            httpClient
                .post(`/common/v1/upload-image`, fd)
                .then((res) => {
                    this.order = {
                        ...this.order,
                        identification_document_image: res.data,
                    };
                })
                .catch((err) => {
                    console.log("uploadFile err", err);
                });
        },
        toggleInfo() {
            this.isShowInfo = !this.isShowInfo;
        },
        scanInput() {
            if (!this.order.contact_value.includes("http")) {
                return false;
            }
            if (this.order.contact_value.includes("wechat.com")) {
                this.order = { ...this.order, id_channel: 16 };
            } else if (this.order.contact_value.includes("kakao.com")) {
                this.order = { ...this.order, id_channel: 15 };
            } else if (this.order.contact_value.includes("zaloapp.com")) {
                this.order = { ...this.order, id_channel: 18 };
            } else if (this.order.contact_value.includes("wa.me")) {
                this.order = { ...this.order, id_channel: 17 };
            } else if (this.order.contact_value.includes("facebook")) {
                this.order = { ...this.order, id_channel: 13 };
            } else if (this.order.contact_value.includes("insta")) {
                this.order = { ...this.order, id_channel: 14 };
            }
        },
    },
};